import React from "react";
import { Card, Text, Grid } from "@tonic/shared/components/ui";
import { LineChart } from "@/components/ui/charts";

export function RecycleFinancialsPage() {
  const mockFinancialData = {
    monthlyRevenue: [
      { month: 'Jan', revenue: 12500 },
      { month: 'Feb', revenue: 15000 },
      { month: 'Mar', revenue: 18000 },
      { month: 'Apr', revenue: 16500 },
      { month: 'May', revenue: 21000 },
      { month: 'Jun', revenue: 19500 }
    ],
    materialCosts: [
      { month: 'Jan', cost: 5000 },
      { month: 'Feb', cost: 5500 },
      { month: 'Mar', cost: 6000 },
      { month: 'Apr', cost: 5800 },
      { month: 'May', cost: 7000 },
      { month: 'Jun', cost: 6500 }
    ],
    operationalMetrics: {
      processingCost: 45.20,
      averageMargin: 32.5,
      recoveryRate: 85.3,
      monthlyVolume: 1250
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <Text variant="h2">Financial Overview</Text>
          <Text variant="body" color="muted">Track recycling program financial performance</Text>
        </div>
      </div>

      <Grid columns={2} gap={6}>
        <Card>
          <div className="p-6">
            <Text variant="h6" className="mb-4">Monthly Revenue</Text>
            <LineChart
              data={mockFinancialData.monthlyRevenue}
              xKey="month"
              yKey="revenue"
              color="#10B981"
            />
          </div>
        </Card>

        <Card>
          <div className="p-6">
            <Text variant="h6" className="mb-4">Material Costs</Text>
            <LineChart
              data={mockFinancialData.materialCosts}
              xKey="month"
              yKey="cost"
              color="#EF4444"
            />
          </div>
        </Card>
      </Grid>

      <Card>
        <div className="p-6">
          <Text variant="h6" className="mb-4">Operational Metrics</Text>
          <Grid columns={4} gap={4}>
            <div className="p-4 bg-gray-50 rounded-lg">
              <Text variant="small" color="muted">Processing Cost (per unit)</Text>
              <Text variant="h4">${mockFinancialData.operationalMetrics.processingCost}</Text>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <Text variant="small" color="muted">Average Margin</Text>
              <Text variant="h4">{mockFinancialData.operationalMetrics.averageMargin}%</Text>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <Text variant="small" color="muted">Recovery Rate</Text>
              <Text variant="h4">{mockFinancialData.operationalMetrics.recoveryRate}%</Text>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <Text variant="small" color="muted">Monthly Volume</Text>
              <Text variant="h4">{mockFinancialData.operationalMetrics.monthlyVolume}</Text>
            </div>
          </Grid>
        </div>
      </Card>
    </div>
  );
}
